import * as budgetAPI from '../../lib/api/budget'
import * as loadingActions from './loading'
import validate from '../../lib/form/validators'

export const HISTORY_UPDATE_HISTORY = 'HISTORY_UPDATE_HISTORY'
export const HISTORY_CLEAR_HISTORY_FILTER = 'HISTORY_CLEAR_HISTORY_FILTER'
export const HISTORY_VALIDATE_FILTER_STEP = 'HISTORY_VALIDATE_FILTER_STEP'
export const HISTORY_STORE_FILTER_VALUE = 'HISTORY_STORE_FILTER_VALUE'

const historyFilterValidation = {
	month: {
		numericality: {
			onlyInteger: true,
			greaterThanOrEqualTo: 1,
			lessThanOrEqualTo: 12
		},
		presence: {
			message: '^A month is required'
		}
	},
	year: {
		numericality: {
			onlyInteger: true,
			greaterThanOrEqualTo: 2000,
			lessThanOrEqualTo: new Date().getFullYear()
		},
		presence: {
			message: '^A year is required'
		}
	}
}

/**
 * Fetches history
 * @param month
 * @param year
 * @param concat
 * @return {function(*=): (Promise.<T>|Promise.<T>)}
 */
export function getHistory(month, year, concat){
	return (dispatch) =>
		loadingActions.promise(
			dispatch,
			HISTORY_UPDATE_HISTORY,
			budgetAPI.getHistory(month, year)
				.then((data) => dispatch(_setHistory(month, year, data, concat)))
		)
}

/**
 * Data type for history data
 * @param month
 * @param year
 * @param history
 * @param concat
 * @return {{type: string, month: *, year: *, history: *, concat: *}}
 * @private
 */
function _setHistory(month, year, history, concat){
	return {
		type: HISTORY_UPDATE_HISTORY,
		month: month,
		year: year,
		history: history,
		concat: concat
	}
}

export function clearHistoryFilter(){
	return {
		type: HISTORY_CLEAR_HISTORY_FILTER
	}
}

function _validateFilterField(field, value){
	return (dispatch) => {
		const fieldConstraints = { [field]: historyFilterValidation[field] }
		const validationResult = validate({[field]: value}, fieldConstraints)

		dispatch(_setValidationResults(validationResult))

		if(typeof(validationResult) !== 'undefined'){
			return Promise.reject(new Error('Failed Validation'))
		}

		dispatch(_clearValidationResult(field))
		return Promise.resolve(true)
	}
}

function _clearValidationResult(field){
	return _setValidationResults({[field]:[]})
}

function _setValidationResults(validationResult){
	return {
		type: HISTORY_VALIDATE_FILTER_STEP,
		validation: validationResult
	}
}

export function storeFilterField(field, value){
	return (dispatch) => {
		dispatch(_setStoreFilterField(field, value))

		return dispatch(_validateFilterField(field, value))
	}
}

function _setStoreFilterField(field, value){
	return {
		type: HISTORY_STORE_FILTER_VALUE,
		field: field,
		value: value
	}
}

export function setHistoryFilter(month, year){
	return (dispatch) => {
		return dispatch(storeFilterField('month', month))
			.then(() => {
				return dispatch(storeFilterField('year', year))
			})
	}
}




// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/actions/history.js